module.exports = __webpack_public_path__ + "static/18_success-criteria-workshop.faeaca44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/18_success-criteria-workshop.jpg
// module id = 490
// module chunks = 110568472390859